"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const _1 = require(".");
const Plugins = tslib_1.__importStar(require("../plugins/"));
const docker_1 = require("../modules/docker");
class BasePlugin {
    constructor() {
        this.isInitialized = false;
        this.windows = new Array();
    }
    initialize() { }
    load() { }
    /**
     * İlgili dosya açık ise o editorden en son halinin verisini, değil ise  sunucudaki en son halini veren bir  promise geri döner.s
     * @param fileInfo istenilen dosyanın solution explorerdaki tam karşılığı
     */
    getFileData(fileInfo) {
        //check file open
        const windowInfo = this.getWindowInfo(fileInfo.id);
        if (windowInfo) {
            const fireActionData = {
                type: _1.ActionTypes.GET_OPEN_FILE_DATA,
                filterPlugin: plugin => false,
                filterWindow: window => window.id === windowInfo.id,
                data: {}
            };
            this.ide.fireAction(fireActionData);
            return {
                data: fireActionData.data
            };
        }
        else {
            const getFileDataPayload = {
                fileInfo: fileInfo
            };
            this.ide.fireAction({
                type: Plugins.SolutionExplorer.ActionTypes.GET_FILE_DATA,
                data: getFileDataPayload,
                filterPlugin: plugin => plugin.id === Plugins.SolutionExplorer.Constants.PluginId
            });
            return getFileDataPayload;
        }
    }
    /**
     * Istenilen windowun durum bilgisini ve window bazındaki datasını içerir
     * @param windowId istenilen windowun id değeri
     */
    getWindowInfo(windowId) {
        let result = null;
        const store = this.ide.getStore();
        if (store && store.getState) {
            const state = store.getState();
            if (state &&
                state.layout &&
                state.layout.window &&
                state.layout.window.items &&
                state.layout.window.items.has(windowId)) {
                result = state.layout.window.items.get(windowId);
            }
        }
        return result;
    }
    onAction(listener) {
        if (listener.type === docker_1.ActionTypes.CLOSE_WINDOW &&
            this.windows.find(i => i.id === listener.data.windowId)) {
            this.windows = this.windows.filter(i => i.id !== listener.data.windowId);
        }
        let returnValue = listener;
        if (this.windows) {
            this.windows.forEach(item => {
                let allow = true;
                if (listener && listener.filterWindow) {
                    allow = listener.filterWindow({
                        id: item.id,
                        name: item.name
                    });
                }
                if (allow && item.onAction) {
                    const newActionData = item.onAction(returnValue);
                    if (newActionData && newActionData.type === listener.type) {
                        returnValue = newActionData;
                    }
                }
            });
        }
        return returnValue;
    }
    loadWindowContent(content) {
        return content;
    }
    reducer(state, action) {
        return state;
    }
}
exports.default = BasePlugin;
//# sourceMappingURL=BasePlugin.js.map